import { Check, Mic, Trash2 } from 'lucide-react';
import { useAnimationLoop, useTypewriter } from './useOnboardingAnim';
import {
  DemoFollowUpTasks,
  DemoNoteTypeHeader,
  DemoSoapSection,
  DemoVitalCard,
} from './e2eDemoComponents';
import { DEMO_ROOT_CLASS } from './onboardingLayout';
import PatientAvatarStack from '../review/PatientAvatarStack';

const REVIEW_PHASES = [1000, 1200, 1200, 1000, 1000, 1200];

const SUBJECTIVE = 'Pain 4/10, improving.';
const PLAN = 'Reassess in 2 hours.';

const DEMO_PATIENTS = [
  { name: 'Layla Yousef' },
  { name: 'Omar Khalil' },
];

export default function ReviewDemoAnimation() {
  const phase = useAnimationLoop(REVIEW_PHASES);

  const subjective = useTypewriter(SUBJECTIVE, phase >= 1, 24);
  const plan = useTypewriter(PLAN, phase >= 2, 24);
  const showVitals = phase >= 3;
  const showFollowUp = phase >= 4;
  const highlightSave = phase >= 5;
  const highlightMic = phase === 1;

  return (
    <div className={`${DEMO_ROOT_CLASS} items-start justify-start pt-1`}>
      <div className="flex w-full flex-col px-1">
        <div className="mb-1 flex shrink-0 items-center justify-start gap-2 px-0.5">
          <PatientAvatarStack patients={DEMO_PATIENTS} size="sm" />
        </div>

        <div className="flex flex-col rounded-xl bg-[#f9fafb] p-1.5">
          <DemoNoteTypeHeader noteType="progress_note" compact />

          <div className="flex flex-col gap-0.5">
            {phase >= 1 && (
              <DemoSoapSection letter="S" label="Subjective" content={subjective} compact />
            )}
            {phase >= 2 && (
              <DemoSoapSection letter="P" label="Plan" content={plan} compact />
            )}

            {showVitals && (
              <div className="grid grid-cols-2 gap-0.5 onboarding-fade-in">
                <DemoVitalCard vitalKey="pain" label="Pain" value="4" unit="/10" compact />
                <DemoVitalCard
                  vitalKey="bp"
                  label="Blood Pressure"
                  value="140/90"
                  unit="mmHg"
                  compact
                />
              </div>
            )}

            {showFollowUp && (
              <div className="onboarding-fade-in">
                <DemoFollowUpTasks tasks={['Reassess pain in 2 hours']} compact />
              </div>
            )}
          </div>

          <div className="mt-1 flex shrink-0 items-center justify-between px-1 pt-1">
            <button
              type="button"
              className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-100 text-gray-500"
            >
              <Trash2 className="h-3 w-3" />
            </button>
            <div className="relative">
              {highlightMic && (
                <div className="onboarding-pulse-ring-primary absolute -inset-1 rounded-full" />
              )}
              <div
                className={`relative flex h-7 w-7 items-center justify-center rounded-full bg-primary text-white transition-transform duration-300 ${
                  highlightMic ? 'scale-95' : ''
                }`}
              >
                <Mic className="h-3.5 w-3.5" />
              </div>
            </div>
            <button
              type="button"
              className={`flex h-7 w-7 items-center justify-center rounded-full bg-success text-white transition-all duration-300 ${
                highlightSave ? 'scale-110 shadow-md' : ''
              }`}
            >
              <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
